const env = {
  isLocal:
      window.location.href.includes('localhost')
      // || window.location.href.includes('192.168.0')
  ,
  isTestMode:
    window.location.href.includes('test') ||
    window.location.href.includes('temp') ||
    window.location.href.includes('dev') ||
    window.location.href.includes('172.30.1') ||
    window.location.href.includes('192.168.0.95'),
    // window.location.href.includes('localhost'),
  isDev:
    window.location.href.includes('test') ||
    window.location.href.includes('dev') ||
    window.location.href.includes('172.30.1')
    // window.location.href.includes('localhost'),
};

export default env;
